export default "__VITE_ASSET__BOEC5WeN__"